import * as Zod from 'zod';

export const colorValidator = () =>
    Zod.string()
        .optional()
        .nullable()
        .transform((val) => {
            if (!val) return val;

            return val.startsWith('#') ? val.slice(1) : val;
        });
